function pushToDataLayer(payload) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}

export const GTM_CONTEXTS = {
  checkoutAdyenDropin: 'Checkout adyen dropin',
  checkoutAdyenDropinNoPayment: 'Checkout adyen dropin no active payment',
  checkoutConfirmationCreateNewUser: 'Checkout confirmation create new user',
  checkoutConfirmationSubmit: 'Checkout confirmation submit',
  checkoutSummaryRemoveUser: 'Checkout info summary remove associated user',
  checkoutUpdateOrder: 'Checkout update order',
  lockedModalSubmit: 'Locked modal submit',
  lockedModalNewsletterSubmit: 'Locked modal newsletter submit',
  npsSubmitResponse: 'NPS submit response',
  pdpCompareShoes: 'PDP compare shoes',
  pdpSubmitReview: 'PDP submit review',
  promoCodeSubmit: 'Promo code submit',
}

export const GTM_ACTIONS = {
  checkout: 'checkout',
}

export const GTM_LABELS = {
  subscribed: 'subscribed',
}

export function trackGtmEvent(event, payload) {
  pushToDataLayer({
    event,
    ...payload,
  })
}
